import { useForm } from "react-hook-form";

export const useEditRankCardSettingsForm = () => {
  const { handleSubmit, register, formState: { isSubmitting } } = useForm();

  return {
    handleSubmit,
    register,
    isSubmitting,
  };
};